import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { isPlatformBrowser } from '@angular/common';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { ApplicationConfig, CSP_NONCE, importProvidersFrom, inject, PLATFORM_ID, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideClientHydration, withEventReplay, withNoIncrementalHydration } from '@angular/platform-browser';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { enIN } from 'date-fns/locale';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { environment } from 'src/environments/environment';
import { routes } from './app.routes';
import { DATE_FORMATS } from './constants';
import { interceptor } from './Interceptors/general-api.interceptor';
import { aiqReportCacheInterceptor } from './modules/aiq/services/aiq-report-cache';
import { CanDeactivateGuard } from './modules/can-deactivate/can-deactivate.guard';
import { SvgRegisterMatIconService } from './services/svg-register-mat-icon.service';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { enableMonacoCspStyleNonce } from './utils/csp-style-nonce.util';

const monacoEditorBaseUrl = typeof window !== 'undefined' 
  ? `${window.location.origin}/assets/monaco-editor/min/vs` 
  : '/assets/monaco-editor/min/vs';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    {
      provide: CSP_NONCE,
      useFactory: (platformId: object) =>
        isPlatformBrowser(platformId)
          ? document.body?.getAttribute('ngCspNonce')
          : null,
      deps: [PLATFORM_ID],
    },
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withXhr(), withInterceptors([interceptor, aiqReportCacheInterceptor])),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !environment.development
    }),
    provideAppInitializer(() => {
      const svgRegisterMatIconService = inject(SvgRegisterMatIconService);
      enableMonacoCspStyleNonce(inject(CSP_NONCE));
      svgRegisterMatIconService.registerIcons();
    }),
    CanDeactivateGuard,
    provideClientHydration(withEventReplay(), withNoIncrementalHydration()),
    ...NgCircleProgressModule.forRoot({}).providers,
    provideDateFnsAdapter(DATE_FORMATS),
    { provide: MAT_DATE_LOCALE, useValue: enIN },
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    importProvidersFrom(MonacoEditorModule.forRoot({
      baseUrl: monacoEditorBaseUrl
    }))
  ]
};
